import { render, staticRenderFns } from "./CwcSvgIcon.vue?vue&type=template&id=2037a88b"
import script from "./CwcSvgIcon.vue?vue&type=script&lang=js"
export * from "./CwcSvgIcon.vue?vue&type=script&lang=js"
import style0 from "./CwcSvgIcon.vue?vue&type=style&index=0&id=2037a88b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports